// extracted by mini-css-extract-plugin
export default {"loginButton":"DemoNotAuthorized_loginButton__pNud0","wrapper":"DemoNotAuthorized_wrapper__rj7M4"};